import 'babel-polyfill'
import Vue from 'vue'
import SwHic, { App } from "sw-hic"
import "sw-hic/sw-hic.css"
import SwHicPatient from "@sunway/patient";
import SwHicDoctor from "@sunway/doctor"
import SwHicHospitalization from "../packages/hospitalization/index";
import router from "@/common/router"
import store from "@/common/store"
Vue.config.productionTip = false

Vue.use(SwHic)
Vue.use(SwHicDoctor)
Vue.use(SwHicPatient)
Vue.use(SwHicHospitalization)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
